/** Strip path segments, null bytes; cap length for a safe `download` attribute. */
export function safeDownloadFileName(name: string): string {
  const trimmed = name.trim()
  const base =
    trimmed.replace(/^.*[\\/]/, '').replace(/\0/g, '') || 'download.bin'
  return base.slice(0, 200)
}

/** Programmatic download (legacy webplatform: object URL + anchor click). */
export function triggerBrowserDownload(blob: Blob, filename: string): void {
  const safe = safeDownloadFileName(filename)
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = safe
  a.rel = 'noopener'
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
